<template>
	<Transition name="toast">
		<div
				v-if="status"
				class="status"
				:class="status.type"
		>
			<span>{{ status.message }}</span>
		</div>
	</Transition>
</template>

<script setup>
import {onMounted, watch} from "vue";

defineProps({
	status: {
		type: Object, // { type: 'success' | 'error' | 'info', message: string } | null
		default: null,
	},
})

// watch(props, () => {
// 	if (props.status) console.log(`[TOAST]`, props.status.message)
// })
</script>

<style scoped>
.status {
	position: fixed;
	bottom: var(--spacing-lg);
	left: 50%;
	transform: translateX(-50%);
	padding: var(--spacing-md) var(--spacing-lg);
	border-radius: var(--border-radius-full);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--spacing-md);
	z-index: 1000;
	min-width: 25vw;
	max-width: 80vw;
	filter: drop-shadow(var(--shadow-md));
	backdrop-filter: blur(var(--blur-sm));
	-webkit-backdrop-filter: blur(var(--blur-sm));
}

.status.success {
	background: var(--color-popup-2, #d4edda);
	color: var(--color-success, #28a745);
	border: var(--border-thin) var(--color-border, #28a745);
}

.status.error {
	background: var(--color-popup-2, #f8d7da);
	color: var(--color-error, #dc3545);
	border: var(--border-thin) var(--color-border, #dc3545);
}

.status.info {
	background: var(--color-popup-2, #d1ecf1);
	color: var(--color-success, #0c5460);
	border: var(--border-thin) var(--color-border, #0c5460);
}

/* Replaced manual v-if show/hide with a Vue <Transition> */
.toast-enter-active {
	animation: slideUp 0.3s ease;
}

.toast-leave-active {
	animation: slideUp 0.2s ease reverse;
}

@keyframes slideUp {
	from {
		opacity: 0;
		transform: translate(-50%, 100%);
	}
	to {
		opacity: 1;
		transform: translate(-50%, 0);
	}
}

@media (max-width: 480px) {
	.status {
		min-width: 90vw;
	}
}
</style>